import type { IconProps } from './types';

export const CancelCircleIcon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M11.9951 2.70996C17.123 2.71002 21.2803 6.86719 21.2803 11.9951C21.2802 17.123 17.123 21.2802 11.9951 21.2803C6.86719 21.2803 2.71002 17.123 2.70996 11.9951C2.70996 6.86715 6.86715 2.70996 11.9951 2.70996ZM16.1514 7.71191C15.8051 7.42954 15.3052 7.42933 14.959 7.71191L14.8877 7.77637L12 10.6641L9.1123 7.77637L9.0957 7.76074L9.0625 7.73047L9.04102 7.71191L8.96973 7.65918C8.62657 7.42934 8.16705 7.4486 7.84375 7.71582L7.77637 7.77637C7.43071 8.12203 7.40894 8.66935 7.71191 9.04102C7.71782 9.04826 7.72416 9.0556 7.73047 9.0625L7.76074 9.0957L7.77637 9.1123L10.6641 12L7.77637 14.8877C7.40771 15.2565 7.4076 15.8549 7.77637 16.2236L7.84863 16.2881C8.21951 16.5905 8.76655 16.5692 9.1123 16.2236L12 13.3359L14.8877 16.2236L14.9043 16.2393L14.9375 16.2695C14.9444 16.2758 14.9517 16.2822 14.959 16.2881L15.0303 16.3408C15.3979 16.5871 15.8995 16.5478 16.2236 16.2236C16.5478 15.8995 16.5871 15.3979 16.3408 15.0303L16.2881 14.959L16.2695 14.9375L16.2393 14.9043L16.2236 14.8877L13.3359 12L16.2236 9.1123L16.2881 9.04102C16.5707 8.69482 16.5705 8.19494 16.2881 7.84863L16.2236 7.77637L16.1514 7.71191Z"
        fill={color}
      />
    </svg>
  );
};
